/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { goodLuckCoreEntitiesRoleSchema } from "./roleSchema.ts";
import { goodLuckCoreEntitiesUserSchema } from "./userSchema.ts";
import { z } from "zod/v4";

export const goodLuckCoreEntitiesUserRoleSchema = z.object({
  userId: z.string().nullish(),
  get role() {
    return goodLuckCoreEntitiesRoleSchema.optional();
  },
  assignedAt: z.optional(z.iso.datetime()),
  get user() {
    return goodLuckCoreEntitiesUserSchema.optional();
  },
});
